import "../node_modules/craxh-ui/app/styles/main.scss";
import "./styles/common.scss";

import Vue from 'vue';
import App from './App.vue';
import LoadingViewPlaceholder from '@/components/LoadingViewPlaceholder';
import supportLocale from '../server/constants/supportLocale';
import axios from 'axios';
import VueTouch from 'vue-touch';
import VueContentPlaceholders from 'vue-content-placeholders'
import queryString from 'query-string'
import UrlParser from 'url-parse'
import hsl2Grayscale from '@/utils/hsl2Grayscale'
import hex2Grayscale from '@/utils/hex2Grayscale'
import getMacauDateTime from '@/utils/getMacauDateTime'
//cx-components
import cxImg from '@/components/cxImg';
import cxLazyImg from '@/components/cxLazyImg';
import cxDropdown from '@/components/cxDropdown';
import cxModal from '@/components/cxModal';
import CraxhUI from '../node_modules/craxh-ui/vue-src';
import cxSlider from '@/components/cxSlider';
import cxSlider2 from '@/components/cxSlider2';
import cxSliderItem from '@/components/cxSliderItem';
import cxSlideVideo from '@/components/cxSlideVideo';
import { createI18n } from './i18n';
import { createRouter } from './router';
import { createStore } from './store';
import { sync } from 'vuex-router-sync';
import { mapState } from 'vuex';
import clickByEnter from "./directives/clickByEnter";
import trapFocus from "./directives/trapFocus";
import GraphemeSplitter from 'grapheme-splitter';
import vueErrorHandler from "./utils/vueErrorHandler";

import { PAGE_VIEW } from './constants/gtmce';

Vue.use(VueTouch, { name: 'v-touch' });
Vue.use(VueContentPlaceholders);

Vue.component('loading-view-placeholder', LoadingViewPlaceholder);
Vue.component('cx-img', cxImg);
Vue.component('cx-lazy-img', cxLazyImg);
Vue.component('cx-dropdown', cxDropdown);
Vue.component('cx-modal', cxModal);
Vue.component('cx-slider', cxSlider);
Vue.component('cx-slider-v2', cxSlider2);
Vue.component('cx-slider-item', cxSliderItem);
Vue.component('cx-slide-video', cxSlideVideo);
Vue.component('cx-video', CraxhUI.Video);

Vue.directive('click-by-enter', clickByEnter);
Vue.directive('trap-focus', trapFocus);

Vue.config.errorHandler = vueErrorHandler;

if (process.env.VUE_ENV === 'server') {
  axios.defaults.baseURL = `http://127.0.0.1:${process.env.PORT || 8080}`;
}
axios.defaults.timeout = 10000;

if (!Vue.prototype.$MIXIN_LOAD || process.env.NODE_ENV == 'development') {
  Vue.prototype.$MIXIN_LOAD = true;
  // watch locale mixin
  const localeMixin = {
    data() {
      return {
        geSplitter: new GraphemeSplitter(),
      }
    },
    mounted() {
      this.loadLazyData();
    },
    computed: {
      ...mapState({
        blackAndWhite: state => state.ui.blackAndWhite,
        contentHost: state => state.ui.contentHost,
        mapVisitorFlowMode: state => state.ui.mapVisitorFlowMode,
      }),
      mgtoMapAccessToken: function () {
        return 'pk.eyJ1IjoibWd0byIsImEiOiJjam56cmV5N3MwOXlnM2tzNW9kZW50aGVtIn0.CcmwJxYXoVjuZzC_bcXpHw';
      },
      mgtoMapStyleDefault: function () {
        // return 'mapbox://styles/mgto/cjnzrfdri45ly2ro2i75rheis';
        return 'mapbox://styles/mgto/cml9653hf005n01s913nv8q26';

      },
      mgtoMapStyleVisitorFlow: function () {
        // return 'mapbox://styles/mgto/cmigx01cq009k01qt49tb2ukj';
        return 'mapbox://styles/mgto/cml98yhgz004901sggiszgnfd';
      },
      mgtoMapStyle: function () {
        return this.mapVisitorFlowMode ? this.mgtoMapStyleVisitorFlow : this.mgtoMapStyleDefault;
      }
    },
    methods: {
      $gtmPush(obj = null) {
        if (!obj || this.$ssrContext) return;
        let dataLayer = (window.dataLayer = window.dataLayer || []);
        console.log('[GTM]: push - ', obj);
        dataLayer.push(obj);
      },
      colorParser(color) {
        if (!this.blackAndWhite) return color;
        if (typeof color != 'string') return '';
        return color.startsWith('hsl')
          ? this.hsl2Grayscale(color)
          : this.hex2Grayscale(color)
      },
      $gtmSet(keyToSet, val = undefined) {
        if (!keyToSet || this.$ssrContext) return;
        let gtmInstance = window.google_tag_manager || {};
        let key = Object.keys(gtmInstance)
          .filter(k => k.indexOf('GTM-') == 0)[0];
        if (!key) return;
        gtmInstance[key].dataLayer.set(keyToSet, val);
      },
      hsl2Grayscale,
      hex2Grayscale,
      localedURL(url) {
        //valid url
        if (!url.startsWith('/')) url = '/' + url;
        let locale = url.split('/')[1];
        if (this.isValidLang(locale)) {
          return url;
        }

        return `/${this.$i18n.locale}${url}`;
      },
      getExperienceSightLink(sight = {}) {
        if (sight.category && sight.group && sight.id) {
          return `/${sight.category}/${sight.group}/${sight.id}`
        }

        return null;
      },
      getQueryString: function () {
        return queryString.stringify(this.$route.query)
      },
      linkProps: function (rawUrl, fallbackDOM = "div") {
        if (typeof rawUrl != 'string') {
          return {
            is: fallbackDOM
          }
        }

        let url = UrlParser(rawUrl, true);
        let hostname = url.hostname.toLowerCase() || 'macaotourism.gov.mo';

        if ((typeof window != 'undefined' && window.location && window.location.hostname == hostname)
          || hostname == 'macaotourism.gov.mo'
          || hostname == 'www.macaotourism.gov.mo'
        ) {
          // return locale lang?
          let path = url.pathname.split('/');
          if (path[0] == '') path.shift();
          // if (this.isValidLang(path[0])) path.shift();
          path = path.join('/');
          let href = url.href;
          let pathIdx = href.indexOf(path);
          path = '/' + (pathIdx ? href.slice(pathIdx) : path)

          return {
            is: 'router-link',
            to: this.localedURL(path)
          }
        } else {
          return {
            is: 'a',
            href: url.href,
            target: '_blank',
            rel: 'noopener noreferrer'
          }
        }
      },
      isValidLang: function (t) {
        t = t.toLowerCase();
        return supportLocale.some(({ locale, disable }) => locale == t && !disable);
      },
      preloadImage: function (url) {
        var img = new Image();
        img.src = url;
      },
      checkIsMobile: function () {
        return this.isIOS() || this.isAndroid()
      },
      isIOS: function () {
        return !!(navigator
          && navigator.userAgent
          && (navigator.userAgent.match('iPad') ||
            navigator.userAgent.match('iPhone') ||
            navigator.userAgent.match('iPod')
          ));
      },
      isAndroid: function () {
        return !!(navigator
          && navigator.userAgent
          && navigator.userAgent.match('Android'))
      },
      parseImg: function (imgSrc, options = {}) {
        /**
         * options = {
         *    ignoreBnw: false,
         *    faceFocus: false,
         *    square: false
         * }
         */
        const parsedImg = UrlParser(imgSrc);
        const ignoreBnw = !!options.ignoreBnw;
        const faceFocus = !!options.faceFocus;
        const square = !!options.square;
        const skipQueryParse = !!options.skipQueryParse;

        if (skipQueryParse) return parsedImg;

        parsedImg.query = queryString.parse(parsedImg.query) || {};

        // impolicy choose
        let bnw = (!ignoreBnw && this.blackAndWhite) ? 'bnw' : '';
        let face = faceFocus ? (square ? 'square' : '16by9') : '';
        if (face) {
          face = `face_${face}${bnw ? '_' : ''}`
        }

        const impolicy = face + bnw;
        if (impolicy) {
          parsedImg.query.impolicy = impolicy;
        }

        return parsedImg;
      },
      parseShortDesc: function (desc = '', addEllipsis = true) {
        let res = desc.replace(/<[^>]*>/g, '');
        return res.length > 0 ? res + (addEllipsis ? '...' : '') : '';
      },
      parseHtmlToShortDesc: function (desc = '', PREFER_LEN = 150, OFFSET = 10, removeHtmlTag = true) {
        if (!desc) return '';
        let res = removeHtmlTag ? desc.replace(/<[^>]*>/g, '') : desc;
        let locale = supportLocale.find(l => l.locale == this.$i18n.locale) || { wordBreakBySpace: false }

        if (locale.wordBreakBySpace) {
          let words = res.split(' ');
          let len = 0;
          res = [];

          while (len < PREFER_LEN && words.length > 0) {
            let nextWord = words.shift();
            len += this.geSplitter.splitGraphemes(nextWord).length;
            res.push(nextWord)
          }

          if (len > PREFER_LEN + OFFSET) {
            res.pop();
          }

          res = res.join(' ');
          if (words.length > 0) {
            res = res.replace(/[-－—– 　.。,﹐，:：︰﹕、;﹔；?﹖？!﹗！…「」]+$/, "")
              .replace(/[\ud800-\udbff]$/, "") + '...';
          }

        } else {
          res = this.geSplitter.splitGraphemes(res);
          if (res.length > PREFER_LEN) {
            let padding = 0;
            const testStr = res.slice(0, PREFER_LEN - OFFSET).join('');
            let hit = /&[a-z]{3,6};/.exec(testStr);
            if (hit && hit.index < OFFSET) {
              padding = hit[0].length - (OFFSET - hit.index);
            }
            // Find out if full chareactor at the end
            res = res.slice(0, PREFER_LEN + padding).join('')
              .replace(/[-－—– 　.。,﹐，:：︰﹕、;﹔；?﹖？!﹗！…「」]+$/, "")
              .replace(/[\ud800-\udbff]$/, "") + '...'
          }
        }

        return Array.isArray(res) ? res.join('') : res;
      },
      getDOMPath: function (dom) {
        let path = [];
        let time = 0;
        while (dom && time < 64) {
          path.push(dom);
          dom = dom.parentNode;
          time += 1;
        }
        return path;
      },
      // host = STATIC / MGTO / WHATSON
      getMediaHost: function (path = '', host = 'STATIC') {
        const MGTO_CONTENT_HOST = this.contentHost || 'https://content.macaotourism.gov.mo/';
        const MGTO_CMS_HOST = MGTO_CONTENT_HOST.includes('mgto-new-cms') ? MGTO_CONTENT_HOST : 'https://cms.macaotourism.gov.mo/';
        const MGTO_MEDIA_HOST = MGTO_CONTENT_HOST.includes('mgto-new-cms') ? MGTO_CONTENT_HOST : 'https://media.macaotourism.gov.mo/';
        const WHATSON_CONTENT_HOST = 'https://whatson.macaotourism.gov.mo/'
        path = path || '';

        if (path.startsWith('http')) {
          return path;
        }

        switch (host) {
          case 'MGTO_MEDIA':
            if (path.charAt(0) == '/') {
              path = path.substr(1);
            }
            return MGTO_MEDIA_HOST + path;
          case 'MGTO':
            if (path.charAt(0) == '/') {
              path = path.substr(1);
            }
            if (path.endsWith('.mp4')) {
              return MGTO_MEDIA_HOST + path;
            }
            return MGTO_CONTENT_HOST + path;

          case 'MGTOCMS':
            if (path.charAt(0) == '/') {
              path = path.substr(1);
            }
            if (path.endsWith('.mp4')) {
              return MGTO_MEDIA_HOST + path;
            }
            return MGTO_CMS_HOST + path;

          case 'WHATSON':
            if (path.charAt(0) == '/') {
              path = path.substr(1);
            }
            return WHATSON_CONTENT_HOST + path;

          default:
            return path
        }
      },
      loadLazyData() {
        this.$options
          && this.$options.lazyData
          && this.$options.lazyData.call(this, {
            i18n: this.$i18n,
            store: this.$store,
            route: this.$route
          })
      }
    },
    watch: {
      '$i18n.locale': function () {
        this.$options
          && this.$options.uit
          && this.$store.dispatch('uit/FETCH_UIT', {
            uitReq: this.$options.uit(),
            i18n: this.$i18n
          })

        this.loadLazyData();
      }
    }
  }

  Vue.mixin({
    filters: {
      timestampToDateTimeString(ts, format = "DD/MM/Y hh:mm:ss") {
        let d = getMacauDateTime(ts * 1000);
        const Y = d.getFullYear();
        const M = d.getMonth() + 1;
        const MM = (M < 10 ? '0' : '') + M;
        const D = d.getDate();
        const DD = (D < 10 ? '0' : '') + D;

        const h = d.getHours();
        const hh = (h < 10 ? '0' : '') + h;
        const m = d.getMinutes();
        const mm = (m < 10 ? '0' : '') + m;
        const s = d.getSeconds();
        const ss = (s < 10 ? '0' : '') + s;

        return format
          .replace('DD', DD)
          .replace('D', D)
          .replace('MM', MM)
          .replace('M', M)
          .replace('Y', Y)
          .replace('ss', ss)
          .replace('s', s)
          .replace('mm', mm)
          .replace('m', m)
          .replace('hh', hh)
          .replace('h', h);
      },
      timestampToDateString(ts, format = "DD/MM/Y") {
        let d = getMacauDateTime(ts * 1000);
        const Y = d.getFullYear();
        const M = d.getMonth() + 1;
        const MM = (M < 10 ? '0' : '') + M;
        const D = d.getDate();
        const DD = (D < 10 ? '0' : '') + D;

        return format
          .replace('DD', DD)
          .replace('D', D)
          .replace('MM', MM)
          .replace('M', M)
          .replace('Y', Y);
      },
      toUpperCase(val) {
        if (!val) return '';
        return val.toString().toUpperCase();
      },
      toLowerCase(val) {
        if (!val) return '';
        return val.toString().toLowerCase();
      },
      capitalize(val) {
        if (!val) return '';
        val = val.toString();
        return val.charAt(0).toUpperCase() + val.slice(1);
      },
    },
    ...localeMixin,
  });
}

export function createApp(context, previewProfile = context?.previewProfile) {
  const i18n = createI18n();
  const router = createRouter(i18n, context, previewProfile);
  const store = createStore(previewProfile);
  sync(store, router);

  /**
   * Handle server-side context here
   * ----------------------------------
   * [context will only pass on server]
   */
  if (context) {
    // update context host
    context.contentHost && store.dispatch('ui/UPDATE_CONTENT_HOST', {
      host: context.contentHost
    });

    // update bnw mode
    store.dispatch('ui/UPDATE_BLACK_AND_WHITE', {
      blackAndWhite: !!context.blackAndWhite
    });

    // Disable Mapbox for crawlers while still allowing content crawling.
    store.dispatch('ui/UPDATE_DISABLE_MAPBOX', {
      disableMapbox: !!context.disableMapbox
    });

    // update map visitor flow mode
    store.dispatch('ui/UPDATE_MAP_VISITOR_FLOW_MODE', {
      mapVisitorFlowMode: !!context.mapVisitorFlowMode
    });
  }

  const app = new Vue({
    router,
    store,
    i18n,
    render: h => h(App)
  })

  router.afterEach((to, from) => {
    if (typeof window !== 'undefined') {
      setTimeout(() => {
        // const params = {};
        // params.element_name = ...
        // params.element_id = ...
        // params.slug = to.fullPath.split('/' + i18n.locale).pop();
        // params.parent_name = ...
        // params.value = 1;
        app.$gtmPush({
          ...PAGE_VIEW,
          // ...params,
          slug: to.path.split('/' + i18n.locale).pop(),
          path: to.fullPath,
          page_title: document.title,
        });
      }, 500);
    }
  });

  return { app, i18n, router, store };
}
